import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/layout/Layout'
import LoginPage from './features/auth/LoginPage'
import RecuperarSenhaPage from './features/auth/RecuperarSenhaPage'
import DashboardPage from './features/dashboard/DashboardPage'
import EquipamentosPage from './features/equipamentos/EquipamentosPage'
import EquipamentoNovoPage from './features/equipamentos/EquipamentoNovoPage'
import EquipamentoImportarPage from './features/equipamentos/EquipamentoImportarPage'
import EquipamentoDetalhePage from './features/equipamentos/EquipamentoDetalhePage'
import PmocPage from './features/pmoc/PmocPage'
import PmocNovaPage from './features/pmoc/PmocNovaPage'
import PmocDetalhePage from './features/pmoc/PmocDetalhePage'
import PmocEditarPage from './features/pmoc/PmocEditarPage'
import OrdensServicoPage from './features/ordens_servico/OrdensServicoPage'
import AprovacoesPage from './features/ordens_servico/AprovacoesPage'
import OrdemServicoDetalhePage from './features/ordens_servico/OrdemServicoDetalhePage'
import OrdemServicoNovaPage from './features/ordens_servico/OrdemServicoNovaPage'
import EmpresaListPage from './features/empresas/EmpresaListPage'
import EmpresaNovaPage from './features/empresas/EmpresaNovaPage'
import EmpresaEditarPage from './features/empresas/EmpresaEditarPage'
import EmpresaDetalhePage from './features/empresas/EmpresaDetalhePage'
import ConfiguracoesPage from './features/configuracoes/ConfiguracoesPage'
import UsuariosListPage from './features/usuarios/UsuariosListPage'
import UsuarioNovoPage from './features/usuarios/UsuarioNovoPage'
import UsuarioDetalhePage from './features/usuarios/UsuarioDetalhePage'
import PerfilPage from './features/usuarios/PerfilPage'
import AuditoriaListPage from './features/auditoria/AuditoriaListPage'
import AuditoriaDetalhePage from './features/auditoria/AuditoriaDetalhePage'
import RelatoriosPage from './features/relatorios/RelatoriosPage'
import SistemaPage from './features/sistema/SistemaPage'
import NotificacoesPage from './features/notificacoes/NotificacoesPage'
import ExecucoesListPage from './features/checklists/ExecucoesListPage'
import ExecucaoChecklistPage from './features/checklists/ExecucaoChecklistPage'
import TemplatesListPage from './features/checklists/TemplatesListPage'
import TemplateDetalhePage from './features/checklists/TemplateDetalhePage'
import TemplateNovoPage from './features/checklists/TemplateNovoPage'
import TemplateImportarPage from './features/checklists/TemplateImportarPage'
import ManualPage from './features/manual/ManualPage'
import OnboardingPage from './features/onboarding/OnboardingPage'
import OnboardingEquipamentosPage from './features/onboarding/OnboardingEquipamentosPage'
import PlanosModeloPage from './features/planos_modelo/PlanosModeloPage'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/recuperar-senha" element={<RecuperarSenhaPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        {/* Equipamentos — static routes BEFORE dynamic /:id */}
        <Route path="equipamentos" element={<EquipamentosPage />} />
        <Route path="equipamentos/novo" element={<EquipamentoNovoPage />} />
        <Route path="equipamentos/importar" element={<EquipamentoImportarPage />} />
        <Route path="equipamentos/:id" element={<EquipamentoDetalhePage />} />
        {/* Sites removido no refator — rota redireciona pra Clientes */}
        <Route path="sites/*" element={<Navigate to="/clientes" replace />} />
{/* PMOC — static routes BEFORE dynamic /:id */}
        <Route path="pmoc" element={<PmocPage />} />
        <Route path="pmoc/novo" element={<PmocNovaPage />} />
        <Route path="planos-modelo" element={<PlanosModeloPage />} />
        <Route path="pmoc/:id/editar" element={<PmocEditarPage />} />
        <Route path="pmoc/:id" element={<PmocDetalhePage />} />
        {/* Ordens de Serviço — static routes BEFORE dynamic /:id */}
        <Route path="ordens-servico" element={<OrdensServicoPage />} />
        <Route path="ordens-servico/novo" element={<OrdemServicoNovaPage />} />
        <Route path="aprovacoes" element={<AprovacoesPage />} />
        <Route path="ordens-servico/:id" element={<OrdemServicoDetalhePage />} />

        {/* Empresas — tela unificada (P1). Páginas legadas redirecionam abaixo. */}
        <Route path="empresas" element={<EmpresaListPage />} />
        <Route path="empresas/novo" element={<EmpresaNovaPage />} />
        <Route path="empresas/:id/editar" element={<EmpresaEditarPage />} />
        <Route path="empresas/:id" element={<EmpresaDetalhePage />} />

        {/* Redirects das páginas legadas pra empresas?papel=X */}
        <Route path="clientes/*" element={<Navigate to="/empresas?papel=CLIENTE" replace />} />
        <Route path="elaboradoras/*" element={<Navigate to="/empresas?papel=PLANEJADOR" replace />} />
        <Route path="executoras/*" element={<Navigate to="/empresas?papel=EXECUTOR" replace />} />
        <Route path="laboratorios/*" element={<Navigate to="/empresas?papel=LABORATORIO" replace />} />

        {/* Relatórios */}
        <Route path="relatorios" element={<RelatoriosPage />} />

        {/* Notificações */}
        <Route path="notificacoes" element={<NotificacoesPage />} />

        {/* Checklists */}
        <Route path="checklists/templates" element={<TemplatesListPage />} />
        <Route path="checklists/templates/novo" element={<TemplateNovoPage />} />
        <Route path="checklists/templates/importar" element={<TemplateImportarPage />} />
        <Route path="checklists/templates/:id" element={<TemplateDetalhePage />} />
        <Route path="checklists/execucoes" element={<ExecucoesListPage />} />
        <Route path="checklists/execucoes/:id" element={<ExecucaoChecklistPage />} />

        {/* Perfil próprio */}
        <Route path="perfil" element={<PerfilPage />} />

        {/* Usuários — admin_tenant */}
        <Route path="usuarios" element={<UsuariosListPage />} />
        <Route path="usuarios/novo" element={<UsuarioNovoPage />} />
        <Route path="usuarios/:id" element={<UsuarioDetalhePage />} />

        {/* Auditoria — admin_tenant */}
        <Route path="auditoria" element={<AuditoriaListPage />} />
        <Route path="auditoria/:id" element={<AuditoriaDetalhePage />} />

        {/* Saúde do sistema */}
        <Route path="sistema" element={<SistemaPage />} />

        {/* Manual de uso */}
        <Route path="manual" element={<ManualPage />} />

        {/* Onboarding wizard */}
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route
          path="onboarding/equipamentos"
          element={<OnboardingEquipamentosPage />}
        />

        {/* Configurações */}
        <Route path="configuracoes/*" element={<ConfiguracoesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
